import React, { PropTypes } from 'react';
import * as B from 'react-bootstrap';

const calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight) {
  const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
  return { width: srcWidth * ratio, height: srcHeight * ratio };
};

class Banner extends React.Component {
  static propTypes = {
    appWidth: PropTypes.number.isRequired,
    appHeight: PropTypes.number.isRequired,
    onBannerHeightChange: PropTypes.func.isRequired,
  };
  static maxWidth = 205;
  static maxHeight = 112;
  static chattyTop = 150;
  constructor(props) {
    super(props);

    this.state = {
      bannerWidth: Banner.maxWidth,
      bannerHeight: Banner.maxHeight,
      chattyTop: Banner.chattyTop,
    };
  }
  resize(props, force) {
    let dimmensions = calculateAspectRatioFit(this.banner.offsetWidth, this.banner.offsetHeight, props.appWidth, props.appHeight),
      bannerHeight = dimmensions.height < Banner.maxHeight ? dimmensions.height : Banner.maxHeight;

    if (force || this.state.bannerHeight !== bannerHeight) {
      this.props.onBannerHeightChange(bannerHeight);
    }
    this.setState({
      bannerWidth: dimmensions.width < Banner.maxWidth ? dimmensions.width : Banner.maxWidth,
      bannerHeight,
    });
  }
  componentDidMount() {
    this.resize(this.props, true);
  }
  componentWillReceiveProps(nextProps) {
    this.resize(nextProps);
  }
  render() {
    return (
      <div
        className="app-banner-wraper"
        ref={c => this.banner = c}
        style={{ width: `${this.state.bannerWidth}px`, height: `${this.state.bannerHeight }px` }}
      >
        <img className="app-banner" src={`${window.TPSOUTHCONE_STATIC_ASSETS_BASE_PUBLIC_URL || ''}static/images/header_mailing.png`} width={this.state.bannerWidth} height={this.state.bannerHeight} />
      </div>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./components/app/Banner.js